export default {
  methods: {
    nc: function (object, field, value = "") {
      if (object) if (object[field]) return object[field];

      return value;
    },
  },
};
